import React from 'react';
import Loader from '../Loader';

const Processing = () => {
  return (
    <div className="overlay payment-processing">
      <p className="processing-message">Payment processing</p>
      <Loader loading={true} />
    </div>
  );
};

export default Processing;
